<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">QHLS പ്രാദേശിക റിപ്പോർട്ട്</h3>
            <p class="text-center text-muted mb-0 small mal-text">{{ levelLabel }}</p>
        </div>
    </div>
    <div id="search">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <div class="input-wrapper">
                        <label class="label" for="pin">Date From</label>
                        <input type="date" class="form-control" name="filter_date_from" v-model="filter_date_from" />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                    <ErrorMessage name="date_from" class="error-feedback" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <div class="input-wrapper">
                        <label class="label" for="pin">Date To</label>
                        <input type="date" class="form-control" name="filter_date_to" v-model="filter_date_to" />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                    <ErrorMessage name="date_to" class="error-feedback" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearFilter()">
                    <ion-icon name="trash-bin-outline" role="img" class="md hydrated" aria-label="add outline"></ion-icon>
                    Clear
                </button>
            </div>
            <div class="col-6">
                <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                    @click="getMembersList()">
                    <ion-icon name="search-outline" role="img" class="md hydrated" aria-label="add outline"></ion-icon>
                    Search
                </button>
            </div>
        </div>
    </div>
    <div class="section">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text text-primary">സെന്ററുകളുടെ എണ്ണം</div>
                    <div class="value text-danger">{{ centersCountTotal }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text text-primary">റിപ്പോർട്ട് അയച്ചത്</div>
                    <div class="value text-success">{{ count_report }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-0" v-if="!loading_list && !hasListData">
        <h4 class="text-center mt-0 mal-text text-muted">{{ emptyListMessage }}</h4>
    </div>
    <div class="section mt-2 mb-2" v-if="!loading_list && hasListData">
        <div class="card qhls-report-card">
            <div class="table-responsive" v-if="user_level <= 3">
                <table class="table table-sm qhls-report-table">
                    <thead>
                        <tr>
                            <th scope="col" class="mal-text">പേര്</th>
                            <th scope="col" class="text-center mal-text col-count">സെന്ററുകൾ</th>
                            <th scope="col" class="text-center mal-text col-count">റിപ്പോർട്ട്</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sub_level in member_lists" :key="sub_level.id">
                            <td class="text-primary">
                                <router-link :to="reportLink(sub_level.id)">
                                    {{ sub_level.name }}
                                </router-link>
                            </td>
                            <td class="text-center text-primary">
                                {{ sub_level.centers || 0 }}
                            </td>
                            <td class="text-center text-success">
                                {{ sub_level.reports || 0 }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="user_level == 4">
                <div class="card pl-2 pr-2 mt-1 mb-2 qhls-zone-report-card"
                    v-for="center in member_lists" :key="centerKey(center)">
                    <div class="listed-detail mt-1">
                        <h5 class="text-center mt-1 mb-0 text-success">{{ center.center_name }}</h5>
                    </div>
                    <ul class="listview flush transparent simple-listview no-space mt-1" v-if="center.has_report">
                        <li>
                            <strong>Date</strong>
                            <span class="text-primary">{{ formatDate(center.date) }}</span>
                        </li>
                        <li>
                            <strong>Time</strong>
                            <span class="text-primary">{{ center.starting_time || '-' }} - {{ center.ending_time || '-' }}</span>
                        </li>
                        <li>
                            <strong>Faculty Time</strong>
                            <span class="text-primary">{{ center.faculty_reporting_time || '-' }}</span>
                        </li>
                        <li>
                            <strong>Attendance</strong>
                            <span class="text-primary">{{ center.attendance || '0/0' }}</span>
                        </li>
                        <li>
                            <strong>Refreshment</strong>
                            <span class="text-primary">{{ center.refreshment == 'Y' ? 'Yes' : 'No' }}</span>
                        </li>
                        <li>
                            <strong>Module Taken</strong>
                            <span class="text-primary">{{ center.module_taken || '-' }}</span>
                        </li>
                        <li>
                            <strong>Added By</strong>
                            <span class="text-primary">{{ reportAddedByName(center) }}</span>
                        </li>
                    </ul>
                    <div class="p-2 text-center" v-else>
                        <p class="text-warning mal-text mb-2">റിപ്പോർട്ട് സമർപ്പിച്ചിട്ടില്ല</p>
                    </div>
                    <div class="p-2 pb-3 text-center">
                        <router-link :to="centerReportLink(center)" class="btn btn-primary btn-sm">
                            View Detailed Report
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
import moment from 'moment';
export default {
    name: 'QHLS Weekly Report',
    components: {
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            filter_date_from: '',
            filter_date_to: '',
            message: "",
            user_level: "",
            member_lists: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            count_total: 0,
            count_report: 0,
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        hasListData() {
            if (this.user_level === 4 && this.count_total > 0) {
                return true;
            }
            return Array.isArray(this.member_lists) && this.member_lists.length > 0;
        },
        levelLabel() {
            if (this.user_level === 1) return 'സംസ്ഥാന റിപ്പോർട്ട്';
            if (this.user_level === 2) return 'ജില്ലാ റിപ്പോർട്ട്';
            if (this.user_level === 3) return 'സോൺ റിപ്പോർട്ട്';
            if (this.user_level === 4) return 'യൂണിറ്റ് റിപ്പോർട്ട്';
            return '';
        },
        emptyListMessage() {
            if (this.user_level === 4 && this.count_total > 0) {
                return 'തിരഞ്ഞെടുത്ത തീയതിയിൽ റിപ്പോർട്ട് സമർപ്പിച്ചിട്ടില്ല';
            }
            return 'തിരഞ്ഞെടുത്ത തീയതിയിൽ ഡാറ്റയൊന്നും കണ്ടെത്തിയില്ല';
        },
        centersCountTotal() {
            if (this.user_level <= 3 && Array.isArray(this.member_lists) && this.member_lists.length) {
                return this.member_lists.reduce(
                    (sum, row) => sum + (parseInt(row.centers, 10) || 0),
                    0
                );
            }
            return this.count_total;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            if(this.$route.query.date_from){
                this.filter_date_from = this.$route.query.date_from;
            }else{
                this.filter_date_from = moment(new Date()).format('YYYY-MM-DD');
            }
            if(this.$route.query.date_to){
                this.filter_date_to = this.$route.query.date_to;
            }else{
                this.filter_date_to = moment(new Date()).format('YYYY-MM-DD');
            }
            this.getMembersList();

            this.$root.updateParent('QHLS പ്രാദേശിക റിപ്പോർട്ട്');
        }

        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    watch: {
        '$route.fullPath'(newPath, oldPath) {
            if (newPath !== oldPath && this.$route.path.includes('qhls-weekly-report')) {
                this.getMembersList();
            }
        },
    },
    methods: {
        reportAddedByName(report) {
            if (report.added_by_name) return report.added_by_name;
            if (report.added_by && report.added_by.name) return report.added_by.name;
            if (report.addedBy && report.addedBy.name) return report.addedBy.name;
            return '-';
        },
        formatDate(date) {
            if (!date) return '-';
            return moment(date).format('DD-MM-YYYY');
        },
        reportLink(id) {
            const query = `?date_from=${this.filter_date_from}&date_to=${this.filter_date_to}`;
            return `/org/${this.user_level + 1}/${id}/qhls-weekly-report${query}`;
        },
        centerReportLink(center) {
            const reportDate = center.has_report && center.date ? center.date : this.filter_date_from;
            let query = `date_from=${reportDate}&date_to=${reportDate}`;
            if (center.report_id) {
                query += `&report_id=${center.report_id}`;
            }
            return `/org/qhls/${center.id}/weekly-report?${query}`;
        },
        centerKey(center) {
            return `${center.id}-${center.report_id || 'none'}`;
        },
        getMembersList() {
            if (!this.filter_date_from || !this.filter_date_to) {
                this.alert_type = 'Warning';
                this.alert_message = 'തീയതി സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (moment(this.filter_date_from).isAfter(moment(this.filter_date_to))) {
                this.alert_type = 'Warning';
                this.alert_message = 'From date cannot be after To date.';
                this.$refs.alert_model.openModel();
                return;
            }

            const data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id, 10),
                date_from: this.filter_date_from,
                date_to: this.filter_date_to,
                type: 'QHLS',
            };

            this.loading_list = true;
            UserService.authPostRequest('get-cre-weekly-report', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.member_lists = response.data.data.list || [];
                        this.count_report = response.data.data.count_report || 0;
                        this.count_total = response.data.data.count_total || 0;
                        if (this.user_level <= 3 && this.member_lists.length) {
                            this.count_total = this.member_lists.reduce(
                                (sum, row) => sum + (parseInt(row.centers, 10) || 0),
                                0
                            );
                        }
                    } else {
                        this.member_lists = [];
                        this.count_report = 0;
                        this.count_total = 0;
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message || 'Unable to load report.';
                        this.$refs.alert_model.openModel();
                    }
                    this.loading_list = false;
                },
                (error) => {
                    this.loading_list = false;
                    this.member_lists = [];
                    this.alert_type = 'Error';
                    this.alert_message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        clearFilter() {
            this.filter_date_from = moment(new Date()).format('YYYY-MM-DD');
            this.filter_date_to = moment(new Date()).format('YYYY-MM-DD');
            this.getMembersList();
        },
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.stat-box .value {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1em;
    color: #27173E;
}

.listview {
    /* margin-bottom: 20px; */
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .total {
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1em;
    font-size: 26px;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px !important;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.qhls-report-card {
    border: none;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
}

.qhls-report-table th,
.qhls-report-table td {
    vertical-align: middle;
    font-size: 14px;
}

.qhls-report-table th {
    background: #f4f7fb;
    color: #1a418c;
    white-space: nowrap;
    font-size: 13px;
}

.qhls-report-table .col-count {
    width: 72px;
    min-width: 72px;
}

.qhls-zone-report-card {
    border: 1px solid #e8eef5;
    border-radius: 10px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 0px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 10px;
    position: relative;
    z-index: 1;
}
.badge {
    border-radius: 0px !important;
}
</style>